import {
  CLOSE_ONBOARDING_STATUS_SUCCESS,
  GET_ONBOARDING_STATUS,
  GET_ONBOARDING_STATUS_ERROR,
  GET_ONBOARDING_STATUS_SUCCESS,
  UPDATE_ONBOARDING_STATUS,
  UPDATE_ONBOARDING_STATUS_ERROR,
  UPDATE_ONBOARDING_STATUS_SUCCESS
} from './OnboardingDialog.actions'

const onboardingDialogState = {
  error: null,
  loading: false,
  open: false
}

/**
 * The onboarding dialog's reducer.
 */
const onboardingDialogReducer = (state = onboardingDialogState, { payload, type }) => {
  switch (type) {
    case CLOSE_ONBOARDING_STATUS_SUCCESS: {
      return { ...state, open: false }
    }
    case GET_ONBOARDING_STATUS:
    case UPDATE_ONBOARDING_STATUS: {
      return { ...state, loading: true }
    }
    case GET_ONBOARDING_STATUS_ERROR:
    case UPDATE_ONBOARDING_STATUS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_ONBOARDING_STATUS_SUCCESS:
    case UPDATE_ONBOARDING_STATUS_SUCCESS: {
      return { ...state, loading: false, open: payload.open }
    }
    default: {
      return state
    }
  }
}

export default onboardingDialogReducer
